import { Link } from "react-router-dom";
import { ArrowUpRight, Heart } from "lucide-react";
import { BUNDLES } from "../data/site";
import { Reveal } from "./motion";

export const BundleAds = () => (
  <section id="bundles" data-testid="bundles-section" className="border-t border-navy/10">
    <div className="mx-auto max-w-[1600px] px-6 pt-28 md:px-12 md:pt-40">
      <Reveal>
        <p className="-rotate-2 font-caveat text-4xl font-semibold text-mustard md:text-5xl">
          make it a bundle
          <Heart className="mb-2 ml-2 inline-block h-6 w-6 fill-mustard text-mustard" />
        </p>
        <h2 className="mt-6 max-w-3xl font-playfair text-4xl leading-[0.95] tracking-tight text-navy md:text-6xl lg:text-7xl">
          Combinations that were made for each other.
        </h2>
        <p className="mt-8 max-w-xl text-sm leading-relaxed text-navy/60 md:text-base">
          We don't sell pre-packed sets — every piece is its own Etsy listing. But these pairings belong together,
          so consider this your cheat sheet. Build the bundle your way, one piece at a time.
        </p>
      </Reveal>
    </div>

    <div className="mt-16 md:mt-20">
      {BUNDLES.map((b, i) => (
        <Reveal key={b.id}>
          <div
            data-testid={`bundle-ad-${b.id}`}
            className={`border-t border-dashed ${b.inverse ? "border-cream/25" : "border-navy/25"} ${b.bg} ${i === BUNDLES.length - 1 ? "border-b" : ""}`}
          >
            <div
              className={`mx-auto flex max-w-[1600px] flex-wrap items-center justify-between gap-8 px-6 py-14 md:px-12 md:py-20 ${
                i % 2 === 1 ? "md:flex-row-reverse" : ""
              }`}
            >
              <div className="max-w-xl">
                <p
                  className={`font-caveat text-2xl font-semibold ${b.inverse ? "text-mustard" : "text-mustard"}`}
                >
                  make it a bundle #{i + 1}
                </p>
                <Link to={`/bundles/${b.id}`} data-testid={`bundle-ad-open-${b.id}`} className="group/title block">
                  <h3
                    className={`mt-3 font-playfair text-4xl leading-[0.98] tracking-tight transition-transform duration-500 group-hover/title:translate-x-2 md:text-6xl ${
                      b.inverse ? "text-cream" : "text-navy"
                    }`}
                  >
                    {b.title}
                  </h3>
                  <p className={`mt-5 text-sm leading-relaxed md:text-base ${b.inverse ? "text-cream/70" : "text-navy/60"}`}>
                    {b.line}
                  </p>
                  <p
                    className={`mt-6 inline-flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.25em] ${
                      b.inverse ? "text-cream/70" : "text-navy/70"
                    }`}
                  >
                    See what works together
                    <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover/title:translate-x-1 group-hover/title:-translate-y-1" />
                  </p>
                </Link>
              </div>
              <div className="flex flex-col items-start gap-4">
                <div className="flex flex-wrap gap-3">
                  {b.parts.map((p) => (
                    <Link
                      key={p.label}
                      to={p.to}
                      data-testid={`bundle-ad-link-${b.id}-${p.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                      className={`group flex items-center gap-2 rounded-full border px-6 py-3 text-xs font-medium uppercase tracking-[0.2em] transition-transform duration-300 hover:scale-95 ${
                        b.inverse
                          ? "border-cream/40 text-cream"
                          : "border-navy bg-navy text-cream"
                      }`}
                    >
                      {p.label}
                      <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </Link>
                  ))}
                </div>
                <p className={`text-[10px] uppercase tracking-[0.3em] ${b.inverse ? "text-cream/50" : "text-navy/50"}`}>
                  Each piece sold separately on Etsy
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
